<template>
    <!--콘텐츠 영역-->
  <div>
    <div id="sub_area">
          <!--비주얼 영역-->
          <div class="sub_visual">
              <div class="tit_area">
                  <h2 class="tit">{{ message }}</h2>
              </div>

              <div class="navigation">
                  <router-link to="/" class="i_home">
                      <span>HOME</span>
                  </router-link>


              </div>
              <div class="sub_visual_img">
                  <img :src="require('./../../assets/img/sub/sub03.png')" alt="BG" />
              </div>
          </div>
    </div>

    <div id="sub_contents" class="sub_contents">

      <a @click="btnNewBoard" v-if="isAdmin" class="admin writing"
          >뉴스룸 게시물 추가</a>
        <a @click="btnWriteEventPopup" v-if="isAdmin" class="admin writing"
          >공지 추가</a
        >


        <button @click="btnTest()" >
          테스트 버튼

        </button>




          </div>
          <router-view/>
      </div>




      <!--
      <div class="News_list">
        <ul class="list">
          <li v-for="(obj, index) in GET_LIST" :key="index">
            <a @click="btnDetail(obj)">
              <dl>
                <dd class="img">
                  <img  :src="obj.MAIN_IMG"/>
                </dd>
                <dt>{{ obj.title }}</dt>
                <dd>{{ obj.createdAt | date }}</dd>
                <dd v-if="isAdmin && obj.bHide">비밀글</dd>
              </dl>
            </a>
          </li>
        </ul>
        <div class="btn_area" v-if="bShowMore">
          <button class="btn_more" @click="btnMore">
            More
            <span>+</span>
          </button>
        </div>
      </div>
      <router-view />

      -->



</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";

import pm from "../common/protocolManager";
import Vue2Filters from "vue2-filters";

export default {
  data: () => ({
    message: "test1.vue",
    isAdmin: false,

  }),
  methods: {
    btnTest() {

      console.log('btnTest');


    },
    btnWriteEventPopup() {
      console.log('btnWriteEventPopup');

    },
    btnNewBoard() {
      console.log('btnNewBoard');

    },
    checkAdmin() {
      let url = "isAdmin";
      pm.get(url)
        .then(result => {
          console.log('isAdmin = true');
          this.isAdmin = true;
        })
        .catch(err => {
          console.log('isAdmin = err');
          this.isAdmin = false;
          if (localStorage.authToken) {
            localStorage.removeItem("authToken");
          }
        });
    },
    admimRegister() {
      let url = "userRegister";
      let params = {
        userId: "admin",
        password: "dkfd2023!@",
        roles: "admin"
      };

      pm.post(url, params)
        .then(result => {
          console.log("admimRegister - ok");
        })
        .catch(err => {
          console.log("admimRegister - err");
        });
    },

  },
  computed: {

    IS_MOBILE() {
      return this.$root.$data.isMobileMode;
    }
  },
  destroyed() { },
  created() {
    console.log("created - " + this.message);

    if (localStorage.authToken) {
      this.checkAdmin();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/layout/test1.vue